<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-yong`]" width="1em" height="1em" v-bind="$attrs"><path d="M114,109.272508 C114,86.0474758 97.5851455,66.3169371 74.9220615,59.3704256 C83.7320291,53.5745295 89.5693733,43.6540245 89.5693733,32.3914201 C89.5693733,14.5241661 74.9629959,0 57,0 C39.0370041,0 24.4306267,14.5241661 24.4306267,32.3773757 C24.4306267,43.6406651 30.2672859,53.5604851 39.0777672,59.3563811 C16.4148545,66.3169371 0,86.0341165 0,109.272508 L0,114 L114,114 L114,109.272508 Z" transform="translate(8 8)" :fill="useCurrentColor ? 'currentColor' : '#4E5969'" fill-rule="evenodd"/></svg>
</template>
<script>

export default {
  name: 'IconPsmYong',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
